export default __webpack_public_path__ + "static/media/home-interior-design-services-03.371ec449.jpg";